import styled from 'styled-components'

export const MessageRowStyled = styled.div<{ $own: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.$own ? 'flex-end' : 'flex-start')};
`

export const MessageGroupStyled = styled.div<{ $own: boolean }>`
  max-width: 85%;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.$own ? 'flex-end' : 'flex-start')};
`

export const MessageBubbleStyled = styled.div<{ $own: boolean }>`
  padding: ${(props) => props.theme.typography.pxToRem(10)}
    ${(props) => props.theme.typography.pxToRem(14)};
  border-radius: ${(props) => props.theme.typography.pxToRem(16)};
  background: ${(props) =>
    props.$own
      ? props.theme.colors.content.accentBackground
      : props.theme.colors.content.secondaryBackground};
  color: ${(props) => props.theme.colors.text.primary};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const MessageMetaStyled = styled.span`
  align-self: center;
  margin-bottom: ${(props) => props.theme.typography.pxToRem(6)};
  font-size: ${(props) => props.theme.typography.pxToRem(13)};
  text-align: center;
`

export const MessageMetaAuthorStyled = styled.span`
  color: ${(props) => props.theme.colors.text.link};
`

export const MessageMetaTimestampStyled = styled.span`
  color: ${(props) => props.theme.colors.text.primary};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`

export const SystemEventMarkerStyled = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.typography.pxToRem(12)};
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  color: ${(props) => props.theme.colors.text.secondary};
  padding: ${(props) => props.theme.space.xsmall} 0;
  white-space: nowrap;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: ${(props) => props.theme.typography.pxToRem(1)};
    background: ${(props) => props.theme.colors.content.secondaryBorder};
  }
`
